module.exports = __webpack_public_path__ + "static/ey-3-d0f9531fd3335c64555af9f8c8582b40.png";